import React from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import DatePicker from 'react-datepicker';
import { ErrorMessageBar, InputError, InputLabel } from 'src/domains/layouts/shared/formComponents/FormComponents.style';
import { FormComponent, FormWrapper, DatesWrapper, DateInputWrapper, SectionHeaderLabel } from 'src/domains/layouts/shared/cms/form/Form.style';
import { OldInput } from 'src/domains/layouts/shared/formComponents/input/OldInput';
import { OldTextarea } from 'src/domains/layouts/shared/formComponents/textarea/OldTextarea';
import { Banners } from '../Banners/Banners';
import { notificationPageButtonOptions } from './selectionOptions';
import { OldSelect } from 'src/domains/layouts/shared/formComponents/Select/components/OldSelect';
import { NotificationPageFormState } from './NotificationPageForm.state';
import { NotificationPageCtaButtonOptions } from './NotificationPageCtaButtonOptions';
import { NotificationPageFilter } from 'src/components/NotificationPage/NotificationPageFilter';
import { FormHeader } from 'src/domains/layouts/shared/cms/form/formHeader/FormHeader';
import { FormButtons } from 'src/domains/layouts/shared/buttons/FormButtons';
import { Loader } from 'src/domains/layouts/shared/loader/Loader';

export const NotificationPageImageForm = observer(() => {
    const { notificationPageState } = useAppStateContext();
    const [ state ] = React.useState(() => new NotificationPageFormState(notificationPageState));
    const { preventDefault, onChangeStartDate, onBlurStartDate, onChangeEndDate, onBlurEndDate, startDateError, endDateError } = state;
    const {
        isLoading,
        errorMessage,
        isFormValid,
        isEditMode,
        handleSubmit,
        handleCancel,
        resetForm,
        startDate, endDate,
        actionTemplate, onChangeActionTemplateCB,
        titleStatus, title, titleModel,
        ctaTextStatus, ctaText, ctaTextModel,
        tcText, tcTextModel, tcTextStatus,
    } = notificationPageState;

    return (
        <FormWrapper>
            <FormHeader isEditMode={isEditMode} defaultLabel='Create new promo page' editModeLabel='Edit promo page' resetForm={resetForm}/>
            <NotificationPageFilter />

            <FormComponent onSubmit={preventDefault}>
                <Loader isActive={isLoading}/>

                {!!errorMessage && <ErrorMessageBar>{errorMessage}</ErrorMessageBar>}

                <OldInput
                    label='Title (max 30 characters)*'
                    status={titleStatus} 
                    formInputState={title}
                    model={titleModel}
                    dataTest='set-promo-title'
                />

                <OldTextarea
                    label='Content'
                    formState={tcText}
                    model={tcTextModel}
                    status={tcTextStatus}
                    dataTest='set-content'
                    ckeditor
                />

                <Banners />

                <OldInput
                    label='Button Label'
                    status={ctaTextStatus}
                    formInputState={ctaText}
                    model={ctaTextModel}
                    dataTest='set-button-label'
                />

                <OldSelect selectOptions={notificationPageButtonOptions} stateValue={actionTemplate} onChange={onChangeActionTemplateCB} dataTest='select-promo-redirection'/>

                <NotificationPageCtaButtonOptions />

                <SectionHeaderLabel>Publishing</SectionHeaderLabel>

                <DatesWrapper>
                    <DateInputWrapper>
                        <InputLabel>Start date *</InputLabel>
                        <DatePicker
                            selected={startDate}
                            onChange={onChangeStartDate}
                            onBlur={onBlurStartDate}
                            showTimeSelect
                            timeFormat='HH:mm'
                            timeIntervals={15}
                            timeCaption='time'
                            dateFormat='MMMM d, yyyy h:mm aa'
                            id='Start-date'
                        />
                        {startDateError ? <InputError>This field is required.</InputError> : null}
                    </DateInputWrapper>
                    <DateInputWrapper>
                        <InputLabel>End date *</InputLabel>
                        <DatePicker
                            selected={endDate}
                            onChange={onChangeEndDate}
                            onBlur={onBlurEndDate}
                            showTimeSelect
                            timeFormat='HH:mm'
                            timeIntervals={15}
                            timeCaption='time'
                            dateFormat='MMMM d, yyyy h:mm aa'
                            id='End-date'
                        />
                        {endDateError ? <InputError>This field is required.</InputError> : null}
                    </DateInputWrapper>
                </DatesWrapper>

                <FormButtons
                    onCreate={handleSubmit}
                    onUpdate={handleSubmit}
                    onCancel={handleCancel}
                    isEditMode={isEditMode}
                    isCreateDisabled={!isFormValid}
                    isUpdateDisabled={!isFormValid}
                    dataTestCreate='create-new-promo-button'
                    dataTestUpdate='create-new-promo-button'
                />
            </FormComponent>
        </FormWrapper>
    );
});

